/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for valueSearchType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="valueSearchType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="startsWith"/&gt; &lt;enumeration value="exactMatch"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class ValueSearchType extends Enum{

	enumValue = null;

	/**
	 * match against the leading portion of the entries in the custom list. Using the example list above, it allows succesful matching of values such as Su, Mo, Tue, Wed.
	 */
	static  STARTS_WITH = ValueSearchType.newLiteral("startsWith");

	/**
	 * match against the whole value of the entries in the custom list.
	 */
	static  EXACT_MATCH = ValueSearchType.newLiteral("exactMatch");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < ValueSearchType.values().length); ++i) {
			if (ValueSearchType.values()[i].enumValue == v) {
				return ValueSearchType.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("ValueSearchType" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/ValueSearchType.js